import React, { useEffect, useState } from "react";
import { useLazyQuery } from "@apollo/client";
import { INITIAL_DATA_TABLE_LIMIT, getImageUrl } from "utils";
import { Box, Typography } from "@mui/material";
import moment from "moment";
import { GET_ALL_MEMBERS } from "components/Members/graphql/query";
import { useNavigate } from "react-router-dom";
import NO_IMAGE from "assets/images/no_image.jpeg";

const MembershipExpiryAlert = () => {
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);

  const [getExpired, { loading, error, data, fetchMore }] = useLazyQuery(
    GET_ALL_MEMBERS,
    {
      variables: {
        first: INITIAL_DATA_TABLE_LIMIT,
        expiryDateStart: moment().format("YYYY-MM-DD"),
        expiryDateEnd: moment().format("YYYY-MM-DD"),
        isDeleted: false,
      },
      fetchPolicy: "network-only",
      notifyOnNetworkStatusChange: true,
      onCompleted: (res) => {
        if (rows.length === 0) {
          const tempRows = res?.members?.edges?.map((e) => e.node);
          setRows(tempRows);
        }
      },
    }
  );

  useEffect(() => {
    if (rows.length === 0) {
      getExpired();
    }
  }, []);

  return (
    <Box>
      <Typography
        sx={{ fontWeight: 600, fontSize: 16, textAlign: "center", mb: 3 }}
      >
        Membership Expired Today
      </Typography>
      {rows.length > 0 &&
        rows.map((item, idx) => {
          return (
            <Box
              key={`${item?.user?.name}_${idx}`}
              onClick={() => navigate(`/admin/members/${item.objectId}`)}
              sx={{
                cursor: "pointer",
                border: "2px solid rgba(0,0,0,.2)",
                mb: 2,
                p: 2,
                borderRadius: "10px",
                display: "flex",
              }}
            >
              <Box
                sx={{
                  height: "40px",
                  width: "40px",
                  borderRadius: "50px",
                  overflow: "hidden",
                }}
              >
                {item.user.photo ? (
                  <img
                    src={getImageUrl(item?.user?.photo)}
                    style={{
                      height: "100%",
                      width: "100%",
                      objectFit: "cover",
                    }}
                  />
                ) : (
                  <img
                    src={NO_IMAGE}
                    style={{
                      height: "100%",
                      width: "100%",
                      objectFit: "cover",
                    }}
                  />
                )}
              </Box>
              <Box sx={{ ml: 2 }}>
                <Typography>{item?.user?.name}</Typography>
                <Typography sx={{ fontSize: 13 }}>
                  {item?.user?.phone}
                </Typography>
              </Box>
            </Box>
          );
        })}
    </Box>
  );
};

export default MembershipExpiryAlert;
